const API_URL = process.env.REACT_APP_API_URL
import BaseApi from "./baseApi"

class PvsApi extends BaseApi {
  constructor() {
    super()
    this.baseUrl = "/pvs"
    this.userUrl = "/users"
    this.bazaarUrl = "/bazaar"
  }
  fetchKeywords(pvsData, token) {
    const endPoint = `${API_URL}${this.baseUrl}/get-pvs-list`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  updatePvsRegistration(pvsData, token) {
    const endPoint = `${API_URL}${this.baseUrl}/pvs-registration`
    const axiosRq = {
      url: endPoint,
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  verifyPvsRegistrationPayment(pvsData, token) {
    const endPoint = `${API_URL}${this.baseUrl}/verify-pvs-payment`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  fetchPvs(token, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/get-pvs-list`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  createPvs(token, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/add-category`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  updatePvs(token, enc_pvs_entry_id, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/edit-pvs/${enc_pvs_entry_id}`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  deletePvs(token, categoryId) {
    const endPoint = `${API_URL}${this.baseUrl}/delete-category/${categoryId}`
    const axiosRq = {
      url: endPoint,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  fetchPvsCategory(token, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/get-pvs-category-list`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  createPvsCategory(token, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/add-pvs-category`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  updatePvsCategory(token, pvsData, enc_pvs_cat_id) {
    const endPoint = `${API_URL}${this.baseUrl}/edit-pvs-category/${enc_pvs_cat_id}`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getPvsCategoryDetails(token, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/get-pvs-category-details/${pvsData.enc_pvs_cat_id}`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }
  fetchPvsSubcategory(token, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/get-pvs-subcategory-list`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  createPvsSubcategory(token, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/add-pvs-subcategory`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  updatePvsSubcategory(token, pvsData, enc_pvs_subcat_id) {
    const endPoint = `${API_URL}${this.baseUrl}/edit-pvs-subcategory/${enc_pvs_subcat_id}`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getPvsSubcategoryDetails(token, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/get-pvs-subcategory-details/${pvsData.enc_pvs_subcat_id}`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }
  fetchPvsKeyword(token, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/get-pvs-keyword-list`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  createPvsKeyword(token, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/add-pvs-keyword`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  updatePvsKeyword(token, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/edit-pvs-keyword/${pvsData.enc_pvs_key_id}`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getPvsKeywordDetails(token, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/get-pvs-keyword-details/${pvsData.enc_pvs_key_id}`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }
  fetchPvsBrand(token, pvsData) {
    const endPoint = `${API_URL}${this.baseUrl}/get-pvs-brand-list`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  fetchStallList(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/get-bazaar-stall-list`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getPvsDetails(pvsData, token) {

    const endPoint = `${API_URL}${this.baseUrl}/get-pvs-details`
    const axiosRq = {
      url: endPoint,
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }
  getPvsDetailsByPvsCardNumber(pvsData, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/get-pvs-detail-by-pvs-card-number`
    const axiosRq = {
      url: endPoint,
      data: pvsData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getBazaarList(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/get-bazaar-list`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getBookingList(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/get-stall-registration-list`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  submitBooking(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/bazaar-stall-registration`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  fetchBookingDetails(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/get-stall-registration-details`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  addBookingPayment(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/add-registered-stall-payment`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  resendInvoice(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/resend-invoice`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getUserBillingInfo(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/get-user-billing-detail`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  regenerateInvoice(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/regenerate-invoice`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  downloadInvoices(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/download-all-invoices`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  downloadBookingReport(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/bazaar-booking-report`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  downloadBalanceReport(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/bazaar-balace-report`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getBazaarStallDetails(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/get-stall-details`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  updateBazaarStallDetails(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/edit-bazaar-stall`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  addBazaarStallDetails(data, token) {

    const endPoint = `${API_URL}${this.bazaarUrl}/add-bazaar-stall`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  addBazaar(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/add-bazaar`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  cancelStallBooking(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/cancel-booked-bazaar-stall`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getAddOnItemList(token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/get-bazaar-stall-add-on-item-list`
    const axiosRq = {
      url: endPoint,
      data: {},
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  deleteAvailableStall(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/delete-available-bazaar-stall`
    const axiosRq = {
      url: endPoint,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getPaymentStatistics(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/payment-statistics`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      // data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  // Product API Methods
  fetchProducts(token) {
    const endPoint = `${API_URL}${this.baseUrl}/get-product-list`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  createProduct(productData, token) {
    const endPoint = `${API_URL}${this.baseUrl}/add-pvs-products`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: productData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  updateProduct(productData, token) {
    const endPoint = `${API_URL}${this.baseUrl}/edit-pvs-product`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: productData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  deleteProduct(enc_product_id, token) {
    const endPoint = `${API_URL}${this.baseUrl}/products/${enc_product_id}`
    const axiosRq = {
      url: endPoint,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  fetchProductDetails(data, token) {
    const endPoint = `${API_URL}${this.baseUrl}/get-pvs-product-detail/${data.enc_product_id}`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getBazaarInterestList(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/get-bazaar-interest-list`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  addBazaarInterest(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/add-bazaar-interest`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getBazaarDetail(enc_bazaar_id, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/get-bazaar-detail/${enc_bazaar_id}`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  editBazaar(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/edit-bazaar`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  downloadBazaarInterestList(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/get-bazaar-interest-excel`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  combineGroupBazaarList(data, token) {
    const endPoint = `${API_URL}${this.bazaarUrl}/combined-group-bazaar-list`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }
}

const pvsApi = new PvsApi()

export default pvsApi
